import BaseFilter from '../modules/filters/baseFilter';
import PopupVideo from '../modules/popupVideo';
import mobileCarousel from '../utils/mobileCarousel';

mobileCarousel(
    'csr-actions__slider',
    'swiper-pagination-csr-actions',
    1.4,
    16,
    false
);

class CalendarTabs {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.tabsEl = this.root.querySelector('.calendar-tabs__tabs');
        this.htmlOutputWrapper = this.root.querySelector(
            '.calendar-tabs__output-wrapper'
        );
        this.loaderWrapper = this.root.querySelector('.calendar-tabs__loader');
        this.buttonWrapper = this.root.querySelector(
            '.calendar-tabs__button-wrapper'
        );
        this.loadMorebutton = this.root.querySelectorAll('.js-load-more');
        this.currentAccordion = null;

        this.value = null;
        this.settings = null;
        this.pageToFetch = 1;
        this.maxNumPages = 1;

        return true;
    }

    init() {
        this.setTabs();

        this.loadMorebutton.forEach(item =>
            item.addEventListener('click', () =>
                this.loadContent(this.value, this.settings)
            )
        );
    }

    setTabs() {
        if (!this.tabsEl) return;
        this.tabs = new BaseFilter(this.tabsEl, this.root);
        this.root.addEventListener('filter-switcher-change', event =>
            this.switchTabs(event)
        );
        this.tabs.toggleClick(1);
    }

    switchTabs(event) {
        const { detail } = event;
        const { value, settings } = detail;

        this.htmlOutputWrapper.innerHTML = '';
        this.pageToFetch = 1;
        this.maxNumPages = 1;

        this.value = JSON.parse(value);
        this.settings = JSON.parse(settings);
        this.loadContent(this.value, this.settings, detail);
    }

    loadContent = async (value, settings, detail) => {
        console.log(value);

        const { post_type } = settings;
        this.loaderWrapper.classList.remove('d-none');
        
        if (value !== null) {
            try {
                const formData = new FormData();
    
                formData.append('value', JSON.parse(value));
                formData.append('action', 'load_calendar_tabs_content');
                formData.append('page', this.pageToFetch);
                formData.append('post_type', post_type);
    
                const req = await fetch(ajax.url, {
                    body: formData,
                    method: 'POST',
                });
    
                const res = await req.json();
    
                const { max_num_pages, html } = res.data;
    
                this.maxNumPages = parseInt(max_num_pages);
                this.pageToFetch = this.pageToFetch + 1;
    
                if (this.maxNumPages >= this.pageToFetch) {
                    this.buttonWrapper.classList.remove('d-none');
                } else {
                    this.buttonWrapper.classList.add('d-none');
                }
    
                if (html) {
                    this.htmlOutputWrapper.insertAdjacentHTML('beforeend', html);
                    if (window.innerWidth < 992) {
                        this.setAccordionGroupContent(detail, html, post_type);
                    }
                }
    
                if (html.includes('card-media')) {
                    const cards = this.root.querySelectorAll('.card-media');
    
                    if (cards && cards.length > 0)
                        cards.forEach(card =>
                            card.addEventListener('click', this.handleCardClick)
                        );
                }
            } catch (error) {
                console.log(`error: ${error}`);
            }
        } else {
            this.setAccordionGroupContent(detail, '', post_type);
        }

        this.loaderWrapper.classList.add('d-none');
    };

    handleCardClick = async e => {
        const { currentTarget } = e;
        const youtubeLink = currentTarget.getAttribute('data-card-media');
        try {
            const formData = new FormData();
            formData.append('action', 'media_popup');
            formData.append('type', 'wideo');
            formData.append('id', youtubeLink);
            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            const res = await req.json();

            if (!res) {
                console.log('error');
                return false;
            }

            const { html } = res;
            document.body.insertAdjacentHTML('beforeend', html);
            const popup = document.querySelector('[data-popup]');
            if (popup) new PopupVideo(popup);
        } catch (error) {
            console.log(error);
        }
    };

    setAccordionGroupContent = (data, html, post_type) => {
        this.resetAccordionTabs();
        let accordionEl = null;
        let activeAccordionButton = null;

        if (data === undefined || data === null) {
            activeAccordionButton = this.root.querySelector(
                '.filter-switcher__button.active'
            );
            accordionEl = activeAccordionButton.nextElementSibling;
        } else {
            const { target } = data;
            accordionEl = target.nextElementSibling;
        }
        this.currentAccordion = accordionEl;

        if (!this.currentAccordion) return;
        const htmlOutputWrapperClone = this.htmlOutputWrapper.cloneNode(true);
        const buttonWrapperClone = this.buttonWrapper.cloneNode(true);
        const buttonClone = buttonWrapperClone.querySelector('.js-load-more');

        htmlOutputWrapperClone.classList.remove('desktop');
        htmlOutputWrapperClone.classList.add('mobile');

        buttonWrapperClone.classList.remove('desktop');
        buttonWrapperClone.classList.add('mobile');

        if (post_type !== 'media')
            this.currentAccordion.innerHTML = htmlOutputWrapperClone.outerHTML;
        if (post_type === 'media' || post_type === null) {
            const isButtonHidden =
                this.buttonWrapper.classList.contains('d-none');

            if (isButtonHidden) {
                this.currentAccordion.innerHTML =
                    htmlOutputWrapperClone.outerHTML;
            } else {
                this.currentAccordion.innerHTML =
                    htmlOutputWrapperClone.outerHTML +
                    buttonWrapperClone.outerHTML;
            }
        }

        this.loadMorebutton = this.root.querySelectorAll('.js-load-more');

        this.loadMorebutton.forEach(item => {
            if (html === '') {
                item.classList.add('d-none');
            } else {
                item.classList.remove('d-none');
            }

            item.addEventListener('click', () =>
                this.loadContent(this.value, this.settings)
            );
        });
    };

    resetAccordionTabs = () => {
        const accordionTabs = this.root.querySelectorAll(
            '.filter-switcher__accordion'
        );
        if (!accordionTabs) return;

        accordionTabs.forEach(item => {
            item.innerHTML = '';
        });
    };
}

const sections = document.querySelectorAll('.calendar-tabs');
const initCalendarTabs = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new CalendarTabs(el);
    });
};

initCalendarTabs(sections);
